// DEV
// export const host = "https://carlsberg-qa.bpower2.com/index.php";
// export const hostCloud = "https://cloud-qa.api.bp2.cloud/cloud_qa";
// export const captchaKey = "6LfIe_0rAAAAAHw1Kq-z5svPcuQwsop6rPKFuHrp";

// QA
// export const host = "https://carlsberg-qa.bpower2.com/index.php";
// export const hostCloud = "https://cloud-qa.api.bp2.cloud/cloud_qa";
// export const captchaKey = "6LfIe_0rAAAAAHw1Kq-z5svPcuQwsop6rPKFuHrp";

// PROD
export const host = "https://admin.carlsbergpolska-biznesportal.pl/index.php";
export const hostCloud = "https://api.bp2.cloud/app";
export const captchaKey = "6LfIe_0rAAAAAHw1Kq-z5svPcuQwsop6rPKFuHrp";

// PRE
// export const host = "https://carlsberg-admin-pre.bpower2.com";
// export const hostCloud = "https://cloud-qa.api.bp2.cloud/app";
// export const captchaKey = "6LfIe_0rAAAAAHw1Kq-z5svPcuQwsop6rPKFuHrp";

/* export const hostCloud = "https://cloud-qa.api.bp2.cloud/app";
export const captchaKey = "6LceYakZAAAAAG7iwQOtUpYX9qilsJzE045xhjry"; */
